export enum StoresConstants {
  AuthStore = 'AUTH_STORE',
  LocationStore = 'LOCATION_STORE',
  MenuStore = 'MENU_STORE',
  CheckoutStore = 'CHECKOUT_STORE',
  LanguageStore = 'LANGUAGE_STORE',
}
